import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'
import promise from 'redux-promise-middleware'
import { errorMiddleware } from '@cheesecakelabs/boilerplate/middlewares'
import Cookies from 'js-cookie'
import { fromJS, Map } from 'immutable'

import rootReducer from '_modules/reducers'

import { COUNTER_VALUE } from '../config/constants'

const router = routerMiddleware(browserHistory)

const DEFAULT_STATE = {
  user: Map({
    token: fromJS(Cookies.get('token')),
    planType: Cookies.get('planType') ? Cookies.get('planType') : 100,
    isAdmin: fromJS(Cookies.get('isAdmin')),
    timeInterval: COUNTER_VALUE / 60,
  }),
}

const configureStore = (preloadedState = DEFAULT_STATE) =>
  createStore(
    rootReducer,
    preloadedState,
    composeWithDevTools(applyMiddleware(thunk, errorMiddleware, promise(), router))
  )

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configure-store.js